/** Set on the request by `_app` when the settings bootstrap failed for a request with a session cookie. */
export const SESSION_UNRESOLVED_REQ_KEY = 'sessionUnresolved';
